import type { Oficio } from '../api/types';

/**
 * O craft em andamento (Renato, 04/11/2026): como a caçada e a coleta, a janela do ofício se minimiza numa pílula no
 * alto enquanto o personagem vai até a ferramenta e faz as peças, e volta com o resultado (ou a falha). A oficina
 * publica aqui; a tela do mundo desenha a pílula e esconde a janela.
 */
export interface CraftAndamento {
  readonly oficio: Oficio;
  readonly nome: string;
  readonly defId: string;
  /** Indo até a ferramenta da cidade, ou fazendo as peças. */
  readonly fase: 'indo' | 'fazendo';
  readonly feitas: number;
  readonly total: number;
  readonly inicio: number;
}

let atual: CraftAndamento | null = null;
const ouvintes = new Set<() => void>();
let parar: (() => void) | null = null;

export const craftAgora = (): CraftAndamento | null => atual;

export function definirCraft(c: CraftAndamento | null, quemPara?: () => void): void {
  atual = c;
  if (quemPara) parar = quemPara;
  if (!c) parar = null;
  for (const f of ouvintes) f();
}

export function ouvirCraft(f: () => void): () => void {
  ouvintes.add(f);
  return () => { ouvintes.delete(f); };
}

/** Parar depois da peça atual (o sair da pílula). */
export function pararCraft(): void {
  parar?.();
}
